import React from 'react'
import Layout from '../../../layouts/Layout'
import { Header, Grid, Button, Icon } from 'semantic-ui-react'
import { data } from '../chartData'
import {
  BarChart, Bar, ReferenceLine, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
  ResponsiveContainer
} from 'recharts'
import { nameToId, excels } from '../mapData'
import './ToolkitComponent.scss'

const toolkitType = ({ params, getChart }) => {
    const colors = ['#5EE6FE', '#224393']
    const names = ['v1', 'v2']
    const typeNames = {
      polarisation: 'Polarisation Detail',
      resilience: 'Resilience Detail'
    }

    const renderXAxis = ({ payload, x, y }) => {
      return <g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={16}
          textAnchor='end'
          fontWeight={payload.value === nameToId[params.id] && 'bold'}
          textDecoration={payload.value === nameToId[params.id] && 'underline'}
          >{payload.value}</text>
      </g>
    }

    const getTitle = (type, chartType) => {
      const typeList = ['Ethnic/Racial', 'Religious', 'Political', 'Gender/Sex/Orientation',
            'Socio-Economic']
      const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1)
      }
      return 'Breakdown of ' + typeList[type] + ' ' +
      capitalizeFirstLetter(chartType) + ' Scores Across the EU'
    }

    return (<Layout link={['Toolkit', params.id, typeNames[params.chartType]]}>
      <Header as='h3'>
        {getTitle(params.type, params.chartType)}
      </Header>
      <p>
        <b>How to interpret scores: </b>
        {data[params.type][params.chartType].subtitle}
      </p>
      {data[params.type][params.chartType].charts.map((chart, i) =>
        <React.Fragment key={i}>
          <Header as='h3'>{chart.title}</Header>
          <ResponsiveContainer width='100%' height={300}>
            <BarChart
                data={chart.data}
                margin={{
                top: 5, right: 5, left: 5, bottom: 5
                }}
            >
              <CartesianGrid strokeDasharray='3 3' />
              <XAxis dataKey='name' tick={renderXAxis} />
              <ReferenceLine y={0} stroke='#aaa' />
              <YAxis type='number' domain={[-3, 3]} ticks={[-3, -2, -1, 0, 1, 2, 3]} />
              <Tooltip />
              <Legend verticalAlign='top' height={36} />
              {chart.dataNames.map((name, i) =>
                <Bar
                key={i}
                dataKey={names[i]}
                fill={colors[i]}
                height={100}
                name={chart.dataNames[i]}
                />)}
            </BarChart>
          </ResponsiveContainer>
          <div style={{ display: 'flex' }}>
            <Header as='h4' style={{ margin: 0, marginRight: 4 }}>Description: </Header>
            {chart.description}
          </div>
          <div style={{ display: 'flex' }}>
            <Header as='h4' style={{ margin: 0, marginRight: 4 }}>Source(s): </Header>
            {chart.source}
          </div>
        </React.Fragment>
        )}
      <Header as='h2' className='greyHeader'>Files</Header>
      <Grid>
        <Grid.Column mobile={16} tablet={4} computer={4}>
          <Icon name='file pdf outline' size='huge' color='red' />
        </Grid.Column>
        <Grid.Column mobile={16} tablet={8} computer={9}>
          <p><b>Name: </b> {getTitle(params.type, params.chartType)}</p>
          <p><b>Format: </b> PDF</p>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={4} computer={3}>
          <Button
              style={{ marginBottom: 20, color: 'white', padding: '30px 0' }}
              size='big'
              onClick={() => {
                getChart(
                  data[params.type][params.chartType],
                  params.type,
                  params.chartType,
                  nameToId[params.id])
                }}
              download
              fluid>
            DOWNLOAD
          </Button>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={4} computer={4}>
          <Icon name='file excel outline' size='huge' color='green' />
        </Grid.Column>
        <Grid.Column mobile={16} tablet={8} computer={9}>
          <p><b>Name: </b> {excels[params.type][params.chartType]}</p>
          <p><b>Format: </b> XLSX</p>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={4} computer={3}>
          <Button
              style={{ marginBottom: 20, color: 'white', padding: '30px 0' }}
              size='big'
              href={`/repository/chartsExcels/${excels[params.type][params.chartType]}`}
              download
              fluid>
            DOWNLOAD
          </Button>
        </Grid.Column>
      </Grid>
    </Layout>)
}

export default toolkitType



// WEBPACK FOOTER //
// ./src/components/ToolkitComponent/components/ToolkitType.js